<template>
  <el-dialog custom-class="min-dialog" :title="title" :visible.sync="dialogFormVisible" :destroy-on-close="true" center :close-on-click-modal="false" :append-to-body="true" :show-close="false" >
    <div style="margin: auto;width: 250px;height: 20px;padding-top: 2px;font-size: 20px;">￥<b>{{form.money|numeric(2)}}元</b></div>
    <div :id="'qrcode'+ewmpre" :ref="'paycode'+ewmpre" style="margin: auto;width: 250px;height: 250px;padding-top: 15px;" v-show="loading"></div>
    <div id="showinfo" style="margin: auto;width: 300px;height: 20px;padding-top: 5px;" v-show="loading">请使用<span style="color: #ff6600;font-size:20px">微信或支付宝</span>扫码支付<span style="color: blue">{{countdown.showinfo}}</span></div>
    <div style="margin: auto;width: 260px;height: 20px;padding-top: 5px;font-size: 11px" v-show="loading">支出成功后会自动跳转，如未跳转<el-button round @click="checkredirect()" size="mini">请点这里</el-button></div>
   <div slot="footer" class="dialog-footer no-print">
     <el-button type="danger"  @click="closedia">暂不支付</el-button>
   </div>
  </el-dialog>
</template>
<script>

  import QRCode from 'qrcodejs2'
  import {checkOrderPay} from '@/api/ossi';

  export default {
    data() {
      return {
        dialogFormVisible: false,
        paydata: {},
        title:'',
        loading: false,
        isdialog: false,
        ssotoken:"",
        form: {
          money: 0.01,//金额
          qrurl: '',
        },
        countdown: {
          showinfo: '',
          count: 60,
          timer: null,
        }
      };
    },
    props:{
      ewmpre:'',
    },
    methods: {
      // {
      //   "msg": "操作成功",
      //   "code": "1",
      //   "unionurl": "https://qr.chinaums.com/bills/qrCode.do?id=36V62410258333542118302205",
      //   "erpserial": "42202410250027",
      //   "price": { "3209001A": 20.00 },
      //   "unionunitguid": "6e9136fce37d4b9f9d49b233ece2bb9a",
      //   "unionemoney": "40.00",
      //   "groupguid": "8f27b2ec-6c0c-4298-809c-0ec7f95a1863",
      //   "paytype": "unionpay"
      // }
      show(paydata,ssotoken) {
        this.dialogFormVisible = true;
        this.ssotoken=ssotoken;
        this.loading = true;
        this.title='单号：'+paydata.erpserial;
        this.paydata = paydata;
        this.form.qrurl = paydata.unionurl;
        this.form.money = paydata.unionemoney;
        this.$nextTick(() => {
          this.waitpay();
        })
      },
      waitpay() {//等待支付
        // console.log(document.getElementById('qrcode'))
        document.getElementById('qrcode'+this.ewmpre).innerHTML = '';

        //1、生成二维码
        let qrcode = new QRCode('qrcode'+this.ewmpre, {
          width: 250,
          height: 250, // 高度
          text: this.form.qrurl, // 二维码内容
          correctLevel: QRCode.CorrectLevel.H
        })

        //2、支付倒计时
        this.countDown();
      },
      countDown() {//倒计时
        const TIME_COUNT = 60 * 30;
        if (!this.countdown.timer) {
          var self = this;
          self.countdown.count = TIME_COUNT;

          self.countdown.timer = setInterval(() => {
            if (self.countdown.count > 0 && self.countdown.count <= TIME_COUNT) {
              self.countdown.count--;

              var seconds = Math.floor(self.countdown.count % 60);
              var msg = '0' + (Math.floor(self.countdown.count / 60)) + " : " + (seconds < 10 ? ('0' + seconds) : seconds);

              self.countdown.showinfo = '（ ' + msg + ' ）';
              if (self.countdown.count < TIME_COUNT - 10 && self.countdown.count % 10 == 0) {
                //检查是否支付成功
                var curTime = new Date();
                checkOrderPay({erpserial: self.paydata.erpserial},self.ssotoken).then(response => {
                  if (response.data && response.data.code == 0) {//支付成功
                    self.redirect();
                  }
                });
              }
            } else {//倒计时结束后取消订单
              self.closedia();
            }
          }, 1000)
        }
      },
      closedia() {
        checkOrderPay({erpserial: this.paydata.erpserial}, this.ssotoken).then(response => {
          if (response.data && response.data.code == 0) {//支付成功
            this.redirect();
          } else {
            this.loading = false;
            this.countdown.showinfo = '';
            clearInterval(this.countdown.timer);
            this.countdown.timer = null;
            this.$emit('CancelUnionPay', this.paydata);
            this.dialogFormVisible = false;
          }
        });
      },
      checkredirect() {
        checkOrderPay({erpserial: this.paydata.erpserial}, this.ssotoken).then(response => {
          if (response.data && response.data.code == 0) {//支付成功
            this.redirect();
          } else {
            this.$message({message: '未检测到支付数据！', type: 'error'});
          }
        });
      },
      redirect() {
        this.loading = false;
        this.countdown.showinfo = '';
        clearInterval(this.countdown.timer);
        this.countdown.timer = null;
        this.$emit('UnionPay', this.paydata);
        this.dialogFormVisible = false;
      },
    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/ewmPay.vue